import React from 'react';
import { motion } from 'framer-motion';

const PageTransition = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 z-[9998] bg-[#0B0B0C] flex items-center justify-center pointer-events-none"
    >
      {/* Small minimal logo */}
      <motion.img
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        src="https://customer-assets.emergentagent.com/job_brand-architects-7/artifacts/s8bzyq96_IMG_9896.PNG"
        alt="Loading"
        className="w-[120px] h-auto"
      />
    </motion.div>
  );
};

export default PageTransition;
